import React, { useEffect, useState } from "react";
import styles from "../styles/Styles";
import CustomizeText from "./CustomizeText";
import { View, Image, Dimensions } from "react-native";
import { emojis } from "../utils/Constants";

const getEmojiImage = (emoji) => {
  return emojis.filter((emojiMap) => emojiMap.id === emoji)[0].img;
};

const getDateTime = (messageDate) => {
  messageDate = new Date(messageDate);
  return messageDate.toLocaleString();
};

const getCheckinMessageCard = (message) => {
  if (message.message !== "") {
   return (
      <View style={styles.checkinMessageCard}>
        <CustomizeText style={styles.checkinMessageText}>
          {message.message}
        </CustomizeText>
        {message.hasOwnProperty("image") ? (
          <Image style={styles.checkinImage} source={{ uri: message.image }} />
        ) : null}
      </View>
   )
  } else {
    return null
  }
}

const CheckinMessageCard = ({ message }) => {
  return (
    <View style={styles.checkInMessageCardContainer}>
      <CustomizeText style={styles.checkinDateTime}>
        {getDateTime(message.date)}
      </CustomizeText>
      <Image style={styles.emojiAvatar} source={getEmojiImage(message.emoji)} />
      { getCheckinMessageCard(message)}
    </View>
  );
};

export default CheckinMessageCard;
